import validate from "/home/runner/work/zotlo-3platform-frontend-generate/zotlo-3platform-frontend-generate/node_modules/nuxt/dist/pages/runtime/validate.js";
import route_45global from "/home/runner/work/zotlo-3platform-frontend-generate/zotlo-3platform-frontend-generate/middleware/route.global.ts";
import manifest_45route_45rule from "/home/runner/work/zotlo-3platform-frontend-generate/zotlo-3platform-frontend-generate/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}